module.exports = __webpack_public_path__ + "img/PMK_20231011_1.d8f55a7f.png";